import { useQuery } from "@tanstack/react-query";
import apiClient, { BASE_URL } from "@apis/index";

export const useSearchFormData = (
  enabled: boolean,
  endpoint: string,
  input?: string,
  queryKey?: string,
  shareType?: string
) => {
  const baseUrl = `${BASE_URL}v3/${endpoint}`;
  const { data, isSuccess, isFetching } = useQuery({
    queryKey: ["GET_SEARCH_FORM_PAYLOAD", endpoint, input],
    enabled,
    cacheTime: 0,
    staleTime: 0,
    queryFn: () => {
      const params = {
        [queryKey || "q"]: input || "",
        share_type: shareType,
      };

      return apiClient.get(baseUrl, {
        baseURL: "",
        params,
      });
    },
    onError: (err) => {
      console.log("err", err);
    },
  });

  return { data: data?.data, isFetching, isSuccess };
};
